import { render, staticRenderFns } from "./GeneralDataProtectionRegulation.vue?vue&type=template&id=742df78a&"
import script from "./GeneralDataProtectionRegulation.vue?vue&type=script&lang=js&"
export * from "./GeneralDataProtectionRegulation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports